import React, { useState } from "react";
import HashtagListWrapper from "./HashtagListWrapper";
import HashtagRow from "./HashtagRow";
import { AddHashtagDialog } from "components/MediaLibrary/modals/AddHashtagDialog";

interface Hashtag {
  hashtag_id: string;
  name: string;
  search_date?: string;
  expired?: boolean;
}

interface Account {
  _id: string;
}

interface ExpiredHashtagsProps {
  account: Account;
  activeHashtags: Hashtag[];
  expiredHashtags: Hashtag[];
}

const ExpiredHashtags: React.FC<ExpiredHashtagsProps> = ({
  account,
  activeHashtags,
  expiredHashtags,
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedHashtagName, setSelectedHashtagName] = useState("");

  const handleHashtagClick = (hashtag: Hashtag) => {
    setSelectedHashtagName(hashtag.name);
    setDialogOpen(true);
  };

  if (expiredHashtags.length === 0) {
    return null;
  }

  return (
    <>
      <HashtagListWrapper
        defaultIsOpen={false}
        title="Expired"
        count={expiredHashtags.length}
      >
        {expiredHashtags.map((hashtag) => {
          return (
            <HashtagRow
              key={hashtag.hashtag_id}
              hashtag={hashtag}
              onClick={() => handleHashtagClick(hashtag)}
            />
          );
        })}
      </HashtagListWrapper>

      <AddHashtagDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        hashtagName={selectedHashtagName}
        account={account}
        activeHashtagsCount={activeHashtags.length}
        title="Reactivate Hashtag"
      />
    </>
  );
};

export default ExpiredHashtags;
